import type { FC, ReactElement, ReactNode, RefObject } from 'react'

import type { WhiteLabel } from '@skytech/types'
import AlertIcon from 'mdi-react/AlertIcon'
import CheckCircleIcon from 'mdi-react/CheckCircleIcon'

import type { ModalVariant } from '../Popup'
import { Popup } from '../Popup'

import './styles.scss'

export type MessageType = 'error' | 'warning' | 'success'

export const MessagePopup: FC<{
  message?: string | ReactElement
  title?: string | ReactElement
  className?: string
  type?: MessageType
  children?: ReactNode
  initialFocusRef?: RefObject<unknown>
  isOpen: boolean
  variant?: ModalVariant
  onClose?: () => void
}> = ({
  message,
  title,
  className = '',
  type = 'error',
  children,
  initialFocusRef,
  isOpen,
  onClose,
  variant = 'medium',
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return (
    <Popup
      initialFocusRef={initialFocusRef}
      ariaLabel={type.toLocaleUpperCase() + 'message'}
      className={`ui-message-popup ${className} ${type} ${whiteLabel} `}
      variant={variant}
      isOpen={isOpen}
      onClose={onClose}
    >
      <h2 className="title flex-1">
        {type === 'success' ? <CheckCircleIcon /> : <AlertIcon />}

        {title}
      </h2>

      <p className="flex-auto overflow-y-auto">{message}</p>

      {children}
    </Popup>
  )
}
